module.exports = __webpack_public_path__ + "img/competition-540x540.57bb2756.jpg";